import request, { Methods, withToken } from "../../../../utils/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ALL_WEEKS_REQUEST = "GET_ALL_WEEKS_REQUEST";
export const GET_ALL_WEEKS_SUCCESS = "GET_ALL_WEEKS_SUCCESS";
export const GET_ALL_WEEKS_ERROR = "GET_ALL_WEEKS_ERROR";

//* ACTIONS ------------------------------------------------
export const getAllWeeksRequest = (payload = {}, callback) => ({
  type: GET_ALL_WEEKS_REQUEST,
  payload,
  callback,
});

export const getAllWeeksSuccess = (data) => ({
  type: GET_ALL_WEEKS_SUCCESS,
  payload: data,
});

export const getAllWeeksError = (error) => ({
  type: GET_ALL_WEEKS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getAllWeeksServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
  });

  return request(`/weeks`, options);
};
